import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Select } from "antd";
import { withRedux } from "../hoc";
import { switchLanguage } from "../actions/language";

const Option = Select.Option;

const mapStateToProps = ({ language }) => {
  return {
    currentLanguage: language.currentActive,
    languages: language.languages
  };
};

const actionToProps = {
  switchLanguage
};

@withRedux(mapStateToProps, actionToProps)
export default class LanguageSwitcher extends PureComponent {
  static propTypes = {
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      })
    ).isRequired,
    currentLanguage: PropTypes.string.isRequired,
    actions: PropTypes.shape().isRequired
  };
  handleSwitchLanguage = language => {
    const { actions, currentLanguage } = this.props;
    if (currentLanguage !== language) {
      actions.switchLanguage(language);
    }
  };
  handleChange = language => {
    const { actions, currentLanguage } = this.props;
    if (currentLanguage !== language) {
      actions.switchLanguage(language);
    }
  };
  render() {
    const { languages, currentLanguage } = this.props;
    return (
      <div>
        <ul className="d-lg-none mobile-mode language-switcher">
          {_.map(languages, language => {
            const languageActive = language.key === currentLanguage ? "active" : "";
            return (
              <li key={language.key} className={`item ${languageActive}`}>
                <a
                  role="button"
                  tabIndex="0"
                  onClick={() => this.handleSwitchLanguage(language.key)}
                  onKeyPress={() => this.handleSwitchLanguage(language.key)}
                >
                  {language.name}
                </a>
              </li>
            );
          })}
        </ul>
        <div className="d-none d-lg-block desktop-mode language-switcher-desktop">
          <Select defaultValue={currentLanguage} style={{ width: 80 }} onChange={this.handleChange} dropdownClassName="header-dropdown-menu">
            {_.map(languages, language => {
              return <Option value={language.key} key={language.key}>{language.name}</Option>;
            })}
          </Select>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.js